function amount(value) {
  return Number(value || 0);
}

function getYearBegin(item, beginKey, debitKey, creditKey) {
  const begin = amount(item && item[beginKey]);
  const debit = amount(item && item[debitKey]);
  const credit = amount(item && item[creditKey]);

  if (item && item.balanceDirection === '贷') {
    return begin + debit - credit;
  }

  return begin - debit + credit;
}

function getYearBeginBalance(item) {
  return getYearBegin(item, 'beginBalance', 'cumulativeDebit', 'cumulativeCredit');
}

function getYearBeginNum(item) {
  return getYearBegin(item, 'num', 'cumulativeDebitNum', 'cumulativeCreditNum');
}

export {getYearBeginBalance, getYearBeginNum};